// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import './signupstyle.css';

// const Signup = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     mobile: '',
//     password: '',
//     city: '',
//     Address: '',
//     dob: '',
//     gender: ''
//   });

//   const [otp, setOtp] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [userEmail, setUserEmail] = useState('');

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const handleGenderSelection = (gender) => {
//     setFormData({
//       ...formData,
//       gender
//     });
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post('http://localhost:4001/signup', formData);
//       console.log('OTP sent:', response.data);
//       setIsOtpSent(true);
//       setErrorMessage('');
//       setUserEmail(formData.email);
//     } catch (error) {
//       console.error('Error sending OTP:', error);
//       if (error.response && error.response.data) {
//         setErrorMessage(error.response.data.message);
//       }
//     }
//   };

//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post('http://localhost:4001/verify-otp', { ...formData, otp });
//       console.log('OTP verified and user created:', response.data);
//       setIsOtpSent(false);
//       onClose();
//     } catch (error) {
//       console.error('Error verifying OTP:', error);
//       if (error.response && error.response.data) {
//         setErrorMessage(error.response.data.message);
//       }
//     }
//   };

//   return (
//     <div className="signup-modal">
//       <div className="signup-modal-content">
//         <div className="close-icon" onClick={onClose}>
//           <FontAwesomeIcon icon={faTimes} />
//         </div>
//         <div className='signup-header'>
//           <h1>User</h1>
//           <div className='signup-underline'></div>
//         </div>
//         {errorMessage && <p className="error-message">{errorMessage}</p>}
//         {!isOtpSent ? (
//           <form className="signup-form" onSubmit={handleSignup}>
//             <div className="form-row">
//               <div className="col">
//                 <input type="text" id="firstName" name="firstName" placeholder='First Name' value={formData.firstName} onChange={handleInputChange} />
//               </div>
//               <div className="col">
//                 <input type="text" id="lastName" name="lastName" placeholder='Last Name' value={formData.lastName} onChange={handleInputChange} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <input type="email" id="email" name="email" placeholder='Email' value={formData.email} onChange={handleInputChange} />
//               </div>
//               <div className="col">
//                 <input type="tel" id="mobile" name="mobile" placeholder='Mobile No' value={formData.mobile} onChange={handleInputChange} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <input type="password" id="password" name="password" placeholder='Password' value={formData.password} onChange={handleInputChange} />
//               </div>
//               <div className="col">
//                 <select id="city" name="city" value={formData.city} onChange={handleInputChange}>
//                   <option value="">Select your City</option>
//                   <option value="Dhaka">Dhaka</option>
//                   <option value="Chattogram">Chattogram</option>
//                   <option value="Barishal">Barishal</option>
//                   <option value="Sylhet">Sylhet</option>
//                   <option value="Rajshahi">Rajshahi</option>
//                   <option value="Khulna">Khulna</option>
//                   <option value="Rangpur">Rangpur</option>
//                   <option value="Maymensingh">Maymensingh</option>
//                 </select>
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <label htmlFor="dob">Date of Birth</label>
//                 <input type="date" id="dob" name="dob" value={formData.dob} onChange={handleInputChange} />
//               </div>
//               <div className="col">
//                 <label>Gender</label>
//                 <div className="checkbox-box">
//                   <input type="checkbox" id="male" name="gender" value="male" checked={formData.gender === 'male'} onChange={() => handleGenderSelection('male')} />
//                   <label htmlFor="male">Male</label>
//                   <input type="checkbox" id="female" name="gender" value="female" checked={formData.gender === 'female'} onChange={() => handleGenderSelection('female')} />
//                   <label htmlFor="female">Female</label>
//                 </div>
//               </div>
//             </div>
//             <button className="submit-btn" type="submit">Sign Up</button>
//           </form>
//         ) : (
//           <form className="otp-form" onSubmit={verifyOtp}>
//             <p className="otp-message">OTP sent to {userEmail}</p>
//             <input type="text" id="otp" name="otp" placeholder='Enter OTP' value={otp} onChange={(e) => setOtp(e.target.value)} className="otp-input" />
//             <button className='otp-button' type='submit'>Verify OTP</button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Signup;


// ***** Upper All codes is okay and checked (22-6-25) ***** //









// ***** Add Translate and update EN-BN (22-6-25) ***** //

// import React, { useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
// import './signupstyle.css';

// const Signup = ({ onClose }) => {
//   const { t } = useTranslation();

//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     mobile: '',
//     password: '',
//     city: '',
//     Address: '',
//     dob: '',
//     gender: ''
//   });

//   const [otp, setOtp] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [userEmail, setUserEmail] = useState('');

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   // const handleGenderSelection = (gender) => {
//   //   setFormData({
//   //     ...formData,
//   //     gender,
//   //   });
//   // };

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     const {
//       firstName,
//       lastName,
//       email,
//       mobile,
//       password,
//       city,
//       dob,
//       gender,
//     } = formData;

//     // validation: make sure every field is filled
//     if (
//       !firstName ||
//       !lastName ||
//       !email ||
//       !mobile ||
//       !password ||
//       !city ||
//       !dob ||
//       !gender
//     ) {
//       // you can define this key in your translation files
//       alert(t("signup.alert.fill_all_required_fields"));
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/signup",
//         formData
//       );
//       console.log("OTP sent:", response.data);
//       setIsOtpSent(true);
//       setErrorMessage("");
//       setUserEmail(formData.email);
//     } catch (error) {
//       console.error("Error sending OTP:", error);
//       if (error.response && error.response.data) {
//         setErrorMessage(error.response.data.message);
//       }
//     }
//   };

//   const verifyOtp = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post('http://localhost:4001/verify-otp', { ...formData, otp });
//       console.log('OTP verified and user created:', response.data);
//       setIsOtpSent(false);
//       onClose();
//     } catch (error) {
//       console.error('Error verifying OTP:', error);
//       if (error.response && error.response.data) {
//         setErrorMessage(error.response.data.message);
//       }
//     }
//   };

//   return (
//     <div className="signup-modal">
//       <div className="signup-modal-content">
//         <div className="close-icon" onClick={onClose}>
//           <FontAwesomeIcon icon={faTimes} />
//         </div>
//         <div className="signup-header">
//           <h1>{t("signup.header")}</h1>
//           <div className="signup-underline"></div>
//         </div>
//         {errorMessage && <p className="error-message">{errorMessage}</p>}
//         {!isOtpSent ? (
//           <form className="signup-form" onSubmit={handleSignup}>
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="text"
//                   id="firstName"
//                   name="firstName"
//                   placeholder={t("signup.form.firstName")}
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <input
//                   type="text"
//                   id="lastName"
//                   name="lastName"
//                   placeholder={t("signup.form.lastName")}
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   placeholder={t("signup.form.email")}
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <input
//                   type="tel"
//                   id="mobile"
//                   name="mobile"
//                   placeholder={t("signup.form.mobile")}
//                   value={formData.mobile}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   placeholder={t("signup.form.password")}
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <select
//                   id="city"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleInputChange}
//                   required
//                 >
//                   <option value="">{t("signup.form.city")}</option>
//                   <option value="Dhaka">{t("signup.form.cities.Dhaka")}</option>
//                   <option value="Chattogram">
//                     {t("signup.form.cities.Chattogram")}
//                   </option>
//                   <option value="Barishal">
//                     {t("signup.form.cities.Barishal")}
//                   </option>
//                   <option value="Sylhet">
//                     {t("signup.form.cities.Sylhet")}
//                   </option>
//                   <option value="Rajshahi">
//                     {t("signup.form.cities.Rajshahi")}
//                   </option>
//                   <option value="Khulna">
//                     {t("signup.form.cities.Khulna")}
//                   </option>
//                   <option value="Rangpur">
//                     {t("signup.form.cities.Rangpur")}
//                   </option>
//                   <option value="Maymensingh">
//                     {t("signup.form.cities.Maymensingh")}
//                   </option>
//                 </select>
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="col">
//                 <label htmlFor="dob">{t("signup.form.dob")}</label>
//                 <input
//                   type="date"
//                   id="dob"
//                   name="dob"
//                   value={formData.dob}
//                   onChange={handleInputChange}
//                   required
//                 />
//               </div>
//               <div className="col">
//                 <label>{t("signup.form.gender.label")}</label>
//                 <div className="checkbox-box">
//                   {/* <input
//                       type="checkbox"
//                       id="male"
//                       name="gender"
//                       value="male"
//                       checked={formData.gender === 'male'}
//                       onChange={() => handleGenderSelection('male')}
//                     /> */}
//                   <input
//                     type="radio"
//                     id="male"
//                     name="gender"
//                     value="male"
//                     checked={formData.gender === "male"}
//                     onChange={handleInputChange}
//                     required
//                   />
//                   <label htmlFor="male">{t("signup.form.gender.male")}</label>
//                   {/* <input
//                       type="checkbox"
//                       id="female"
//                       name="gender"
//                       value="female"
//                       checked={formData.gender === 'female'}
//                       onChange={() => handleGenderSelection('female')}
//                     /> */}

//                   <input
//                     type="radio"
//                     id="female"
//                     name="gender"
//                     value="female"
//                     checked={formData.gender === "female"}
//                     onChange={handleInputChange}
//                   />
//                   <label htmlFor="female">
//                     {t("signup.form.gender.female")}
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <button className="submit-btn" type="submit">
//               {t("signup.form.submit")}
//             </button>
//           </form>
//         ) : (
//           <form className="otp-form" onSubmit={verifyOtp}>
//             <p className="otp-message">
//               {t("signup.otp.message", { email: userEmail })}
//             </p>
//             <input
//               type="text"
//               id="otp"
//               name="otp"
//               placeholder={t("signup.otp.placeholder")}
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               className="otp-input"
//             />
//             <button className="otp-button" type="submit">
//               {t("signup.otp.submit")}
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
//   };
  
//   export default Signup;








// ***** New Upldate (11-sep-25) ***** //

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, Link } from "react-router-dom";
import "./signupstyle.css";
import { URL } from "../../config";

const BD_MOBILE_REGEX = /^01[3-9]\d{8}$/;

const Signup = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Minimal fields only
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName]   = useState("");
  const [mobile, setMobile]       = useState("");
  const [password, setPassword]   = useState("");

  // UI / error
  const [errMsg, setErrMsg] = useState("");

  // OTP state
  const [showOtp, setShowOtp] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [otpId, setOtpId] = useState(null);
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpErr, setOtpErr] = useState("");
  const [otpSeconds, setOtpSeconds] = useState(60);
  const [successTimer, setSuccessTimer] = useState(5);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const isSubmitting = sendingOtp || verifyingOtp;

  // keep data to finalize after OTP
  const pendingRef = useRef(null);

  // OTP countdown
  useEffect(() => {
    if (!showOtp) return;
    const timer = setInterval(() => {
      setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [showOtp]);

  // Success redirect timer
  useEffect(() => {
    if (!showSuccess) return;
    setSuccessTimer(5);
    const interval = setInterval(() => {
      setSuccessTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onClose?.();
          navigate("/login");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [showSuccess, navigate, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");

    // basic requireds
    if (!firstName || !lastName || !mobile || !password) {
      setErrMsg(t("signup.error.required") || "Please fill out all required fields");
      return;
    }
    if (!BD_MOBILE_REGEX.test(mobile)) {
      setErrMsg(t("signup.error.invalid_mobile_format") || "Enter a valid mobile number (01XXXXXXXXX).");
      return;
    }

    // keep payload for after OTP
    pendingRef.current = { firstName, lastName, mobile, password };

    try {
      setSendingOtp(true);

      // 1) precheck mobile
      await axios.post(`${URL}/users/precheck`, { mobile });

      // 2) start OTP
      // const { data } = await axios.post(`${URL}/otp/start`, { mobile });
      const { data } = await axios.post(`${URL}/otp/start`, { mobile, purpose: "signup_user" });

      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setShowOtp(true);
      if (typeof data.expiresIn === "number") setOtpSeconds(data.expiresIn);
      else setOtpSeconds(60);
    } catch (error) {
      const status = error.response?.status;
      const backendMsg = (error.response?.data?.error || "").toLowerCase();
      const body = error.response?.data;

      if (status === 429) {
        const wait = body?.retryAfter;
        setErrMsg(
          wait
            ? `Please wait ${wait}s before requesting another code.`
            : "Too many OTP requests. Try again later."
        );
        return;
      }

      if (status === 409 && backendMsg.includes("mobile")) {
        setErrMsg(t("signup.error.mobile_exists") || "This mobile is already registered.");
      } else if (status === 400 && (backendMsg.includes("mobile") || backendMsg.includes("phone"))) {
        setErrMsg(t("signup.error.invalid_mobile_format") || "Enter a valid mobile number (01XXXXXXXXX).");
      } else {
        setErrMsg(body?.error || (t("signup.otp.failed_to_send") || "Failed to send verification code."));
      }
    } finally {
      setSendingOtp(false);
    }
  };

  // finalize after OTP verification
  const finishSignup = async () => {
    const p = pendingRef.current;
    if (!p) return;
    // await axios.post(`${URL}/users`, p);
    await axios.post(`${URL}/users`, { ...p, otpId });
  };

  // OTP handlers
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 1);
    const next = [...otpDigits];
    next[index] = value;
    setOtpDigits(next);

    if (value && index < 5) {
      const el = document.querySelector(`input[data-index="${index + 1}"]`);
      el?.focus();
    }
    if (next.every((d) => d.length === 1)) verifyOtp(next.join(""));
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const next = [...otpDigits];
      if (next[index]) {
        next[index] = "";
        setOtpDigits(next);
      } else if (index > 0) {
        next[index - 1] = "";
        setOtpDigits(next);
        const prev = document.querySelector(`input[data-index="${index - 1}"]`);
        prev?.focus();
      }
    }
  };

  const handleOtpPaste = (e, index) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;

    const next = [...otpDigits];
    pasted.split("").forEach((c, i) => {
      if (index + i < 6) next[index + i] = c;
    });
    setOtpDigits(next);
    const focusIndex = Math.min(index + pasted.length - 1, 5);
    document.querySelector(`input[data-index="${focusIndex}"]`)?.focus();

    if (next.every((d) => d)) verifyOtp(next.join(""));
  };

  const verifyOtp = async (code) => {
    if ((code || "").length !== 6) {
      setOtpErr(t("signup.otp.error_enter_code") || "Enter the 6-digit code.");
      return;
    }
    setVerifyingOtp(true);
    try {
      // await axios.post(`${URL}/otp/verify`, { otpId, code });
      await axios.post(`${URL}/otp/verify`, { otpId, code, purpose: "signup_user" });

      await finishSignup();
      setShowOtp(false);
      setShowSuccess(true);
    } catch (err) {
      const msg = err.response?.data?.error || t("signup.otp.error_invalid") || "Invalid or expired code.";
      setOtpErr(msg);
      setOtpDigits(["", "", "", "", "", ""]);
      setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
    } finally {
      setVerifyingOtp(false);
    }
  };

  const resendOtp = async () => {
    if (otpSeconds > 0) return;
    try {
      setSendingOtp(true);
      // const { data } = await axios.post(`${URL}/otp/start`, { mobile });
      const { data } = await axios.post(`${URL}/otp/start`, {
        mobile,
        purpose: "signup_user",
      });
      
      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
      setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
    } catch (err) {
      setOtpErr(t("signup.otp.failed_to_resend") || "Failed to resend code.");
    } finally {
      setSendingOtp(false);
    }
  };

  return (
    <div className="signup-modal">
      <div className="signup-modal-content">
        {/* <div className="close-icon" onClick={onClose}> */}
        <div
           className={`close-icon ${isSubmitting ? "is-disabled" : ""}`}
           onClick={isSubmitting ? undefined : onClose}
           aria-disabled={isSubmitting}
           role="button"
         >
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="signup-header">
          <h1>{t("signup.header") || "User"}</h1>
          <div className="signup-underline" />
        </div>

        {errMsg && <div className="error-message">{errMsg}</div>}

        <form className="signup-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="col">
              <input
                type="text"
                placeholder={t("signup.form.firstName") || "First Name"}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                disabled={isSubmitting || showOtp}
              />
            </div>
            <div className="col">
              <input
                type="text"
                placeholder={t("signup.form.lastName") || "Last Name"}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={isSubmitting || showOtp}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="col">
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]{11}"
                maxLength={11}
                placeholder={t("signup.form.mobile_ph") || "01XXXXXXXXX"}
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))}
                required
                disabled={isSubmitting || showOtp}
              />
            </div>
            <div className="col">
              <div className="signup-password-wrap">
              <input
                // type="password"
                type={showPassword ? "text" : "password"}
                placeholder={t("signup.form.password") || "Password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isSubmitting || showOtp}
                autoComplete="new-password"
              />
              {/* For view password */}
              <button
                type="button"
                className="signup-password-toggle-btn"
                onClick={() => setShowPassword((s) => !s)}
                disabled={isSubmitting || showOtp}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
              </div>
            </div>
          </div>

          {/* <button
            className="submit-btn"
            type="submit"
            disabled={sendingOtp || verifyingOtp || showOtp}
          >
            {sendingOtp
              ? (t("signup.sending_code") || "Sending code...")
              : (t("signup.form.submit") || "Sign Up")}
          </button> */}

          <button
            className={`signupUsersubmit-btn ${isSubmitting ? "is-loading" : ""}`}
            type="submit"
            disabled={isSubmitting || showOtp}
            aria-busy={isSubmitting}
            aria-live="polite"
          >
            {isSubmitting && <span className="signupbtn-spinner" aria-hidden="true" />}
            <span className="signupbtn-text">
              {isSubmitting
                ? (t("signup.sending_code") || "Sending code...")
                : (t("signup.form.submit") || "Sign Up")}
            </span>
          </button>

          {/* Legal line under the button */}
          <p className="legal-note">
            {t("signup.legal.prefix") || "By signing up, you agree to our"}{" "}
            <strong>
              {/* <a
                href="/legal/terms-and-privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="legal-link"
              >
                {t("signup.legal.link") || "Terms & Privacy Policy"}
              </a> */}

              <Link to="/legal/terms-and-privacy" className="legal-link">
                {t("signup.legal.link") || "Terms & Privacy Policy"}
              </Link>
            </strong>
            .
          </p>
        </form>
      </div>

      {/* OTP Modal */}
      {showOtp && (
        <div className="servitorsignupotp-overlay">
          <div className="servitorsignupotp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="servitorsignupotp-header">
              <div className="servitorsignupotp-header-content">
                <div className="servitorsignupotp-icon-container">
                  <div className="servitorsignupotp-icon-bg">
                    <svg className="servitorsignupotp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <div className="servitorsignupotp-pulse-ring" />
                </div>
                <div>
                  <h2 className="servitorsignupotp-title">{t("signup.otp.title") || "Verify Your Phone"}</h2>
                  <p className="servitorsignupotp-sub">
                    {t("signup.otp.sub", { mobile }) || `Enter the 6-digit code sent to ${mobile}`}
                  </p>
                </div>
              </div>
              <button className="servitorsignupotp-close" onClick={() => setShowOtp(false)}>
                <svg className="servitorsignupotp-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="servitorsignupotp-body">
              <div className="servitorsignupotp-input-section">
                <label className="servitorsignupotp-label">
                  {t("signup.otp.label") || "Verification Code"}
                </label>
                <div className="servitorsignupotp-inputs">
                  {otpDigits.map((d, idx) => (
                    <input
                      key={idx}
                      type="text"
                      inputMode="numeric"
                      autoComplete={idx === 0 ? "one-time-code" : undefined}
                      maxLength="1"
                      className="servitorsignupotp-input"
                      value={d}
                      onChange={(e) => handleOtpChange(e, idx)}
                      onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                      onPaste={(e) => handleOtpPaste(e, idx)}
                      onFocus={(e) => e.target.select()}
                      autoFocus={idx === 0}
                      data-index={idx}
                      disabled={verifyingOtp || sendingOtp}
                    />
                  ))}
                </div>
              </div>

              {otpErr && <div className="servitorsignup-inline-error">{otpErr}</div>}

              <div className="servitorsignupotp-timer-section">
                <div className="servitorsignupotp-timer-content">
                  <svg className="servitorsignupotp-timer-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="servitorsignupotp-timer-text">
                    {otpSeconds > 0
                      ? (t("signup.otp.timer_text", { seconds: otpSeconds }) || `Resend code in ${otpSeconds}s`)
                      : (t("signup.otp.no_code") || "Didn't receive the code?")}
                  </span>
                </div>
                {otpSeconds === 0 && (
                  <button className="servitorsignupotp-resend" onClick={resendOtp} disabled={sendingOtp || verifyingOtp}>
                    {t("signup.otp.resend") || "Resend Code"}
                  </button>
                )}
              </div>

              <div className="servitorsignupotp-actions">
                <button
                  className="servitorsignupotp-verify-btn"
                  onClick={() => verifyOtp(otpDigits.join(""))}
                  disabled={verifyingOtp || sendingOtp || !otpDigits.every((d) => d)}
                >
                  {verifyingOtp
                    ? (t("signup.otp.verifying") || "Verifying...")
                    : (t("signup.otp.verify") || "Verify Code")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success modal */}
      {showSuccess && (
        <div className="servitorsignupotp-overlay">
          <div className="servitorsignupotp-success-modal" onClick={(e) => e.stopPropagation()}>
            <div className="servitorsignupotp-success-icon-container">
              <div className="servitorsignupotp-success-icon-bg">
                <svg className="servitorsignupotp-success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <h3 className="servitorsignupotp-success-title">{t("signup.success.title") || "Verification Successful!"}</h3>
            <p className="servitorsignupotp-success-sub">
              {t("signup.success.sub") || "Your registration is complete. Please login to continue."}
            </p>
            <p className="servitorsignupotp-success-timer">
              {t("signup.success.redirect", { seconds: successTimer }) || `Redirecting to login in ${successTimer} seconds...`}
            </p>
            <button
              className="servitorsignupotp-success-btn"
              onClick={() => {
                onClose?.();
                navigate("/login");
              }}
            >
              {t("signup.success.continue") || "Continue to Login"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Signup;
